import React from 'react';
import './App.css';
import CssBaseline from "@mui/material/CssBaseline";
import {Hoc} from './hoc';
import {SubscriptionPlusAccessForm} from '@components/SubscriptionPlusAccessForm';
import {SignUpForm} from '@components/SignUpForm';
import {ReferralForm} from '@components/ReferralForm';
import { Container } from '@mui/material';

import {
    HashRouter as Router,
    Link,
    Route,
    Switch,
} from 'react-router-dom';

export default function App() {
    return (
        <Router>
            <Switch>
                <Container>
                    <Hoc>
                        <CssBaseline />
                        <Switch>
                            <Route exact path='/subsciption_plus_access' component={SubscriptionPlusAccessForm}/>
                            <Route exact path='/sign_up_form' component={SignUpForm}/>
                            <Route path='/referral_form' component={ReferralForm}/>
                        </Switch>
                    </Hoc>
                </Container>
            </Switch>
        </Router>

    );
}


